// ** React Imports
import { forwardRef } from 'react'

// ** Third Party Components
import Proptypes from 'prop-types'
import { Badge } from 'reactstrap'
import classnames from 'classnames'

import { getInitials } from '@src/utility/data/convertedData'

import './styles.scss'
import { STRINGS } from '../../utility/_helpers/strings'
import { ARRAYS } from '../../utility/data/arrays'


const Avatar = forwardRef((props, ref) => {
  // ** Props
  const { color, className, imgClassName, initials, size, badgeUp, content, icon, badgeColor, badgeText, img, imgHeight, imgWidth, status, tag: Tag, contentStyles, userDefaultAvatar, ...rest } = props

  return (
    <Tag
      className={classnames('avatar', {
        [className]: className,
        [`bg-${color}`]: color,
        [`avatar-${size}`]: size
      })}
      ref={ref}
      {...rest}
    >
      {img === false || img === undefined || !img ? (

        <span
          className={classnames('avatar-content', {
            'position-relative': badgeUp
          })}
          style={contentStyles}
        >
          {userDefaultAvatar}
          {initials ? getInitials(content) : content}
          {icon ? icon : null}
          {badgeUp ? (
            <Badge color={badgeColor ? badgeColor : 'primary'} className='badge-sm badge-up' pill>
              {badgeText ? badgeText : '0'}
            </Badge>
          ) : null}
        </span>
      ) : (
        <img
          className={classnames({
            [imgClassName]: imgClassName
          }, 'img-cover')}
          src={img}
          alt=''
          height={imgHeight && !size ? imgHeight : 32}
          width={imgWidth && !size ? imgWidth : 32}
        />
      )}
      {status ? (
        <span
          className={classnames({
            [`avatar-status-${status}`]: status,
            [`avatar-status-${size}`]: size
          })}
        ></span>
      ) : null}
    </Tag>
  )
})

export default Avatar

// ** PropTypes
Avatar.propTypes = {
  imgClassName: Proptypes.string,
  className: Proptypes.string,
  src: Proptypes.string,
  tag: Proptypes.oneOfType([Proptypes.func, Proptypes.string]),
  badgeUp: Proptypes.bool,
  content: Proptypes.string,
  icon: Proptypes.node,
  contentStyles: Proptypes.object,
  badgeText: Proptypes.string,
  imgHeight: Proptypes.oneOfType([Proptypes.string, Proptypes.number]),
  imgWidth: Proptypes.oneOfType([Proptypes.string, Proptypes.number]),
  size: Proptypes.oneOf(['sm', 'lg', 'xl']),
  status: Proptypes.oneOf(ARRAYS.STATUSES),
  badgeColor: Proptypes.oneOf([
    STRINGS.COLORS.PRIMARY,
    STRINGS.COLORS.SECONDARY,
    STRINGS.COLORS.SUCCESS,
    STRINGS.COLORS.DANGER,
    STRINGS.COLORS.INFO,
    STRINGS.COLORS.WARNING,
    STRINGS.COLORS.DARK,
    STRINGS.COLORS.LIGHT_PRIMARY,
    STRINGS.COLORS.LIGHT_SECONDARY,
    STRINGS.COLORS.LIGHT_SUCCESS,
    STRINGS.COLORS.LIGHT_DANGER,
    STRINGS.COLORS.LIGHT_INFO,
    STRINGS.COLORS.LIGHT_WARNING,
    STRINGS.COLORS.LIGHT_DARK
  ]),
  
  color: Proptypes.oneOf([
    STRINGS.COLORS.PRIMARY,
    STRINGS.COLORS.SECONDARY,
    STRINGS.COLORS.SUCCESS,
    STRINGS.COLORS.DANGER,
    STRINGS.COLORS.INFO,
    STRINGS.COLORS.WARNING,
    STRINGS.COLORS.DARK,
    STRINGS.COLORS.LIGHT_PRIMARY,
    STRINGS.COLORS.LIGHT_SECONDARY,
    STRINGS.COLORS.LIGHT_SUCCESS,
    STRINGS.COLORS.LIGHT_DANGER,
    STRINGS.COLORS.LIGHT_INFO,
    STRINGS.COLORS.LIGHT_WARNING,
    STRINGS.COLORS.LIGHT_DARK
  ]),
  initials(props) {
    if (props['initials'] && props['content'] === undefined) {
      return new Error('content prop is required with initials prop.')
    }
    if (props['initials'] && typeof props['content'] !== 'string') {
      return new Error('content prop must be a string.')
    }
    if (typeof props['initials'] !== 'boolean' && props['initials'] !== undefined) {
      return new Error('initials must be a boolean!')
    }
  }
}

// ** Default Props
Avatar.defaultProps = {
  tag: 'div'
}
